import { Check, Question } from '@tunasong/icons'
import type { FC, HTMLAttributes, MouseEvent } from 'react'
import { Button } from '@tunasong/ui-lib'
import styles from './vote-button.module.css'

export interface VoteButtonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  status: boolean | undefined
  disabled?: boolean
  onChange?(ev: MouseEvent, val: boolean): void
}

export const VoteButton: FC<VoteButtonProps> = props => {
  const { status, disabled, onChange, ...restProps } = props
  const startIcon = status ? (
    <div className={styles.iconSuccess}>
      <Check />
    </div>
  ) : disabled ? null : (
    <div className={styles.iconDisabled}>
      <Question />
    </div>
  )
  const handleClick = (ev: MouseEvent<HTMLButtonElement>) => {
    const newStatus = !status
    if (onChange) {
      onChange(ev, newStatus)
    }
  }

  return (
    <div className={styles.container} {...restProps}>
      {startIcon}
      {!disabled ? (
        <Button onClick={handleClick} disabled={disabled}>
          <div className={status === true ? styles.unvoteText : undefined}>
            {status === false ? 'Vote' : null}
            {status === true ? 'Unvote' : null}
          </div>
        </Button>
      ) : null}
    </div>
  )
}

export default VoteButton
